const defaultState = {
  data: {
    allGeographies: {},
    allIndicators: {},
    indicator: {},
    isFetching: [],
    tableFilter: [],
    chartColorsUsed: [],
    seriesAdd: false,
    tableFilterToggle: false,
    landingMeta: {
      usdata: {},
      international: {},
    },
    uiFlag: false,
  },
};

export default defaultState;



// WEBPACK FOOTER //
// ./app/config/defaultState.js